import React from "react";
import Dialog from "@mui/material/Dialog";
import { Form, Formik, FormikHelpers, FormikProps } from "formik";
import { StudentFilterDialogValues } from "src/models/Student.model";
import StudentFilterDialog from "./StudentFilterDialog";
import { setDateFilter, setBatches } from "src/redux/slices/StudentSlice";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "src/redux/store";

type Props = {
  onClose: () => void;
};

const StudentFilterDialogWrapper = ({ onClose }: Props) => {
  const dispatch = useDispatch();
  const { dateFilter , batches } =
  useSelector((state: RootState) => state.student);

  // Form Initial Values
  const initialValues: StudentFilterDialogValues = {
    nextInstallmentStartDate: "",
    nextInstallmentEndDate: "",
    startDate: dateFilter?.start_date || null,
    endDate:dateFilter?.end_date || null,
    batchs:batches?.map((el:any)=>{
      return{
        label:el?.label ,
        value:el?.value
      }
    }),
  };
 

  // Handle Submit
  const handleSubmit = (
    values: StudentFilterDialogValues,
    { setSubmitting, resetForm }: FormikHelpers<StudentFilterDialogValues>
  ) => {
    dispatch(
      setDateFilter({
        start_date: values?.startDate,
        end_date: values?.endDate,
      })
    );
   dispatch(setBatches(values?.batchs))
   setSubmitting(false) 
   onClose()
  };
  const handleReset = (formikProps: FormikProps<StudentFilterDialogValues>) => {
    dispatch(setDateFilter({
      start_date:null,
      end_date: null,
    })) ;
    dispatch(setBatches([])) ;}

  return (
    <Dialog open maxWidth="xs" fullWidth>
      <Formik
        initialValues={initialValues}
        onSubmit={handleSubmit}
       
      >
        {(formikProps) => (
          <Form>
            <StudentFilterDialog formikProps={formikProps} onClose={onClose}  onReset={handleReset}  />
          </Form>
        )}
      </Formik>
    </Dialog>
  );
};

export default StudentFilterDialogWrapper;
